var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "user-page" } },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "col-5" }, [
          _c("h5", [_vm._v(_vm._s(_vm.pageTitle))]),
        ]),
        _c("div", { staticClass: "col-3 d-flex justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-danger btn_left",
              attrs: { id: "destroyBtn", type: "button" },
              on: { click: _vm.destroy },
            },
            [_vm._v("削除する")]
          ),
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info",
              attrs: { id: "backBtn", type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("キャンセルする")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.modify(null)
                },
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phoneNumber,
                          expression: "phoneNumber",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "13",
                        autocomplete: "off",
                        placeholder: [[_vm.phoneNumberDisplayHolder]],
                        required: "",
                      },
                      domProps: { value: _vm.phoneNumber },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.phoneNumber = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.extensionNumber,
                          expression: "extensionNumber",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "13",
                        autocomplete: "off",
                        placeholder: [[_vm.extensionNumberDisplayHolder]],
                      },
                      domProps: { value: _vm.extensionNumber },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.extensionNumber = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactName,
                          expression: "contactName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "70",
                        autocomplete: "off",
                        placeholder: [[_vm.contactNameDisplayHolder]],
                      },
                      domProps: { value: _vm.contactName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.contactName = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn btn-block",
                  attrs: { id: "register_button", type: "submit" },
                },
                [_vm._v("更新する")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("外線番号")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("内線番号")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("表示名")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }